
    import Component from "vue-class-component"
    import {Prop} from "vue-property-decorator";
    import Vue from 'vue';
    import {ValidityStatus} from "@/api-client";
	import {ls} from "@/CultureService";

    @Component
    export default class ValidityStatusBadge extends Vue {
        @Prop()
        validity!: ValidityStatus;

        validityStatusMap: { [id: string]: {cssClass: string, text:string}; } = {
            [ValidityStatus.Unchecked] : {cssClass: "badge badge-secondary", text: ls.Global_ValidityState_Unchecked},
            [ValidityStatus.Valid] : {cssClass: "badge badge-success", text: ls.Global_ValidityState_Valid},
            [ValidityStatus.Invalid] : {cssClass: "badge badge-danger", text: ls.Global_ValidityState_Invalid}
        };
    }
